<template>
  <section class="testimonial-section" :style="styles">
    <div class="grid grid--container">
      <div class="testimonial-section__content">
        <span class="testimonial-section__stars">
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <span class="sr-only">5 stars</span>
        </span>

        <VText class="testimonial-section__title" component="h2" variant="h3">{{
          title
        }}</VText>

        <blockquote class="testimonial-section__quote">
          <slot />
          <cite>- {{ name }}</cite>
        </blockquote>
      </div>

      <div class="testimonial-section__device">
        <ScaledDevice class="device" :width="428" :height="868" ref="preview">
          <DeviceIphone>
            <nuxt-img
              :src="imgSrc"
              :sizes="`xs:500px`"
              :quality="85"
              alt="Campsite.bio profile"
            />
          </DeviceIphone>
        </ScaledDevice>
      </div>
    </div>
  </section>
</template>

<script>
import {
  Button,
  ScaledDevice,
  DeviceIphone,
  VText,
  useTheme,
  StarIcon,
} from '@campsite-bio/component-lib';
import tinycolor from 'tinycolor2';
import { computed } from '@vue/composition-api';

export default {
  components: {
    ScaledDevice,
    DeviceIphone,
    VText,
    StarIcon,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    imgSrc: {
      type: String,
      required: true,
    },
  },

  setup() {
    const theme = useTheme();

    const styles = computed(() => {
      return {
        '--c-bg-color': tinycolor(theme.value.colors.primary)
          .setAlpha(0.1)
          .toRgbString(),
      };
    });

    return {
      styles,
    };
  },
};
</script>

<style lang="scss" scoped>
.testimonial-section {
  background: var(--c-bg-color);
  padding-bottom: 3rem;
  padding-top: 3rem;

  .grid {
    display: grid;
    grid-gap: 4rem;
    max-width: 900px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 250px;
    }
  }

  &__stars {
    color: #faba05;
    display: flex;
    gap: 0.15rem;
    font-size: 1.5rem;
  }

  &__device {
    justify-self: center;
  }
}

.testimonial-section__title.testimonial-section__title {
  margin: 1rem 0;
}

blockquote {
  font-size: 1rem;
  margin: 0;
  color: #444;
  padding: 0 0 0 2.75em;
  line-height: 1.6;
  position: relative;

  p {
    margin-bottom: 0.5rem;
  }

  cite {
    display: block;
    margin-top: 0.75rem;
  }

  &::before {
    display: inline-flex;
    font-family: Arial;
    content: '\201C';
    color: var(--g-color-primary);
    font-size: 4em;
    line-height: 1;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.device {
  margin: 0 auto;
  width: 250px;
  z-index: 1;

  &::v-deep {
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;

      &:first-child {
        z-index: 1;
      }
    }
  }
}
</style>
